const prefix = 'cvf-admin/orders/';

export const GET_SKUS = `${prefix}GET_SKUS`;
export const GET_SKUS_SUCCESS = `${prefix}GET_SKUS_SUCCESS`;
export const GET_SKUS_ERROR = `${prefix}GET_SKUS_ERROR`;

export const CREATE_ORDER = `${prefix}CREATE_ORDER`;
export const CREATE_ORDER_SUCCESS = `${prefix}CREATE_ORDER_SUCCESS`;
export const CREATE_ORDER_ERROR = `${prefix}CREATE_ORDER_ERROR`;

export const PURCHASE_ORDER = `${prefix}PURCHASE_ORDER`;
export const PURCHASE_ORDER_SUCCESS = `${prefix}PURCHASE_ORDER_SUCCESS`;
export const PURCHASE_ORDER_ERROR = `${prefix}PURCHASE_ORDER_ERROR`;
